module.exports = __webpack_public_path__ + "img/tablet-elbow-8_70x64.d0f86f88.png";